import * as React from 'react';
import styled from 'styled-components';
import UAParser from 'ua-parser-js';
import Thumbnail from './partials/Thumbnail';

type Props = {
  games: any[];
  onClick(slug: string): void;
};

const GamesContainer = styled.div`
  display: flex;
  position: relative;
  flex-wrap: wrap;
  margin-top: 24px;
  width: 100%;
  max-width: 1024px;
  justify-content: center;
`;

const GameRoot = styled.div`
  width: calc((100% - 12px) / 2);

  @media screen and (min-width: 768px) {
    width: calc((100% - 48px) / 2);
  }
  @media screen and (min-width: 960px) {
    width: calc((100% - 90px) / 4);
  }
`;

const GameItem = styled.div`
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  margin: 8px;
  height: 167px;
  text-decoration: none;
`;

const GameSlug = styled.div`
  position: relative;
  margin: 0 8px 8px;
  color: ${({ theme }): string => theme.white};
  font-size: 16px;
  font-weight: ${({ theme }): number => theme.regular};
  letter-spacing: 0.17px;
  line-height: 20px;
  opacity: 0.6;
`;

// TODO: replace with CasinoGameGrid and CasinoGame from core
export const CasinoGameSection: React.FC<Props> = ({ games, onClick }) => {
  const uaResult = new UAParser().getResult();
  const device = React.useMemo(() => {
    let device = 'PC';
    if (
      uaResult.device.type === 'mobile' ||
      uaResult.device.type === 'tablet'
    ) {
      if (uaResult.device.vendor === 'Apple' && uaResult.device.model) {
        device = uaResult.device.model;
      } else if (uaResult.os.name === 'Android') {
        device = uaResult.os.name;
      }
    }
    return device;
  }, [uaResult]);

  return (
    <GamesContainer>
      {games
        .filter((game) => game)
        .map((game, index) => {
          return (
            <GameRoot key={`${game.gameSlug.en}${index}`}>
              <GameItem
                onClick={() =>
                  onClick(
                    device === 'PC'
                      ? game.gameSlug.en
                      : game.mobileGameSlug?.en || game.gameSlug.en
                  )
                }
                key={`${game.gameSlug.en}${index}`}
              >
                <Thumbnail
                  backgroundUrl={
                    game.backgroundImageAsset
                      ? game.backgroundImageAsset.url
                      : game.backgroundUrl?.en
                  }
                  logoUrl={game.logoImage?.url ?? game.logoImage?.file?.en.url}
                  gameFlag={game.gameFlag?.en}
                  dropsAndWins={game.tournamentGame?.en}
                />
              </GameItem>
              <GameSlug>{game.gameDisplayName?.en}</GameSlug>
            </GameRoot>
          );
        })}
    </GamesContainer>
  );
};

export default CasinoGameSection;
